import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/property-5.png'
import _imports_1 from '@/assets/images/user-1.jpg'
import _imports_2 from '@/assets/images/property-6.png'
import _imports_3 from '@/assets/images/user-2.jpg'
import _imports_4 from '@/assets/images/property-7.png'
import _imports_5 from '@/assets/images/user-3.jpg'
import _imports_6 from '@/assets/images/property-9.png'
import _imports_7 from '@/assets/images/user-5.jpg'
import _imports_8 from '@/assets/images/property-10.png'
import _imports_9 from '@/assets/images/user-6.jpg'
import _imports_10 from '@/assets/images/property-11.png'
import _imports_11 from '@/assets/images/user-7.jpg'
import _imports_12 from '@/assets/images/property-12.png'
import _imports_13 from '@/assets/images/user-8.jpg'
import _imports_14 from '@/assets/images/property-13.png'
import _imports_15 from '@/assets/images/user-9.jpg'
import _imports_16 from '@/assets/images/property-14.png'
import _imports_17 from '@/assets/images/user-10.jpg'
import _imports_18 from '@/assets/images/property-15.png'
import _imports_19 from '@/assets/images/user-11.jpg'
import _imports_20 from '@/assets/images/property-16.png'
import _imports_21 from '@/assets/images/user-12.jpg'
import _imports_22 from '@/assets/images/property-8.png'
import _imports_23 from '@/assets/images/user-4.jpg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-6 col-xl-6 col-xxl-4" }
const _hoisted_3 = { class: "card border-0 rounded-3 bg-white property-list-hover mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }
const _hoisted_6 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center" }
const _hoisted_7 = { class: "col-sm-6 col-xl-6 col-xxl-4" }
const _hoisted_8 = { class: "card border-0 rounded-3 bg-white property-list-hover mb-4" }
const _hoisted_9 = { class: "card-body p-4" }
const _hoisted_10 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }
const _hoisted_11 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center" }
const _hoisted_12 = { class: "col-sm-6 col-xl-6 col-xxl-4" }
const _hoisted_13 = { class: "card border-0 rounded-3 bg-white property-list-hover mb-4" }
const _hoisted_14 = { class: "card-body p-4" }
const _hoisted_15 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }
const _hoisted_16 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center" }
const _hoisted_17 = { class: "col-sm-6 col-xl-6 col-xxl-4" }
const _hoisted_18 = { class: "card border-0 rounded-3 bg-white property-list-hover mb-4" }
const _hoisted_19 = { class: "card-body p-4" }
const _hoisted_20 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }
const _hoisted_21 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center" }
const _hoisted_22 = { class: "col-sm-6 col-xl-6 col-xxl-4" }
const _hoisted_23 = { class: "card border-0 rounded-3 bg-white property-list-hover mb-4" }
const _hoisted_24 = { class: "card-body p-4" }
const _hoisted_25 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }
const _hoisted_26 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center" }
const _hoisted_27 = { class: "col-sm-6 col-xl-6 col-xxl-4" }
const _hoisted_28 = { class: "card border-0 rounded-3 bg-white property-list-hover mb-4" }
const _hoisted_29 = { class: "card-body p-4" }
const _hoisted_30 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }
const _hoisted_31 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center" }
const _hoisted_32 = { class: "col-sm-6 col-xl-6 col-xxl-4" }
const _hoisted_33 = { class: "card border-0 rounded-3 bg-white property-list-hover mb-4" }
const _hoisted_34 = { class: "card-body p-4" }
const _hoisted_35 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }
const _hoisted_36 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center" }
const _hoisted_37 = { class: "col-sm-6 col-xl-6 col-xxl-4" }
const _hoisted_38 = { class: "card border-0 rounded-3 bg-white property-list-hover mb-4" }
const _hoisted_39 = { class: "card-body p-4" }
const _hoisted_40 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }
const _hoisted_41 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center" }
const _hoisted_42 = { class: "col-sm-6 col-xl-6 col-xxl-4" }
const _hoisted_43 = { class: "card border-0 rounded-3 bg-white property-list-hover mb-4" }
const _hoisted_44 = { class: "card-body p-4" }
const _hoisted_45 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }
const _hoisted_46 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center" }
const _hoisted_47 = { class: "col-sm-6 col-xl-6 col-xxl-4" }
const _hoisted_48 = { class: "card border-0 rounded-3 bg-white property-list-hover mb-4" }
const _hoisted_49 = { class: "card-body p-4" }
const _hoisted_50 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }
const _hoisted_51 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center" }
const _hoisted_52 = { class: "col-sm-6 col-xl-6 col-xxl-4" }
const _hoisted_53 = { class: "card border-0 rounded-3 bg-white property-list-hover mb-4" }
const _hoisted_54 = { class: "card-body p-4" }
const _hoisted_55 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }
const _hoisted_56 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center" }
const _hoisted_57 = { class: "col-sm-6 col-xl-6 col-xxl-4" }
const _hoisted_58 = { class: "card border-0 rounded-3 bg-white property-list-hover mb-4" }
const _hoisted_59 = { class: "card-body p-4" }
const _hoisted_60 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }
const _hoisted_61 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center" }
const _hoisted_62 = { class: "col-lg-12" }
const _hoisted_63 = { class: "card border-0 bg-white p-4 mb-4 rounded-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("h3", { class: "mb-0" }, "New York", -1)
              ]))]),
              _: 1
            }),
            _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div>", 1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/real-estate/property-overview",
            class: "text-decoration-none d-block mb-4"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_0,
                class: "rounded-2",
                alt: "property"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"d-flex justify-content-between mb-3\"><h3 class=\"mb-0 text-danger\">$18,000</h3><span class=\"text-success bg-success bg-opacity-10 d-inline-block fs-12 px-2 rounded-2\"> Sale </span></div><div class=\"d-flex align-items-center mb-3\"><span class=\"material-symbols-outlined fs-20 text-primary\"> location_on </span><span class=\"ms-1\">35 Prince Consort Road</span></div><ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap gap-2 gap-md-4 border-top border-bottom py-2 mb-4\"><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\"> bed </span><span class=\"ms-2\">6 Bed</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\"> bathtub </span><span class=\"ms-2\">5 Bath</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\"> square_foot </span><span class=\"ms-2\">1800 sqft</span></div></li></ul>", 3)),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/agent-overview",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    style: {"width":"40px","height":"40px"},
                    class: "rounded-circle border border-white",
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-16 fw-semibold" }, "Harold Cook"),
                  _createElementVNode("span", { class: "fs-13 text-body" }, "Owner")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-primary fs-15 text-decoration-none read"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" View More ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createElementVNode("h3", { class: "mb-0" }, "London", -1)
              ]))]),
              _: 1
            }),
            _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div>", 1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/real-estate/property-overview",
            class: "text-decoration-none d-block mb-4"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createElementVNode("img", {
                src: _imports_2,
                class: "rounded-2",
                alt: "property"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"d-flex justify-content-between mb-3\"><h3 class=\"mb-0 text-danger\">$220,000</h3><span class=\"text-primary bg-primary bg-opacity-10 d-inline-block fs-12 px-2 rounded-2\"> Rent </span></div><div class=\"d-flex align-items-center mb-3\"><span class=\"material-symbols-outlined fs-20 text-primary\"> location_on </span><span class=\"ms-1\">58 Gateway Road Portland</span></div><ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap gap-2 gap-md-4 border-top border-bottom py-2 mb-4\"><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\"> bed </span><span class=\"ms-2\">8 Bed</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\"> bathtub </span><span class=\"ms-2\">6 Bath</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\"> square_foot </span><span class=\"ms-2\">2000 sqft</span></div></li></ul>", 3)),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/agent-overview",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_3,
                    style: {"width":"40px","height":"40px"},
                    class: "rounded-circle border border-white",
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-16 fw-semibold" }, "Debra Sisk"),
                  _createElementVNode("span", { class: "fs-13 text-body" }, "Owner")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-primary fs-15 text-decoration-none read"
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode(" View More ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createElementVNode("h3", { class: "mb-0" }, "France", -1)
              ]))]),
              _: 1
            }),
            _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div>", 1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/real-estate/property-overview",
            class: "text-decoration-none d-block mb-4"
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createElementVNode("img", {
                src: _imports_4,
                class: "rounded-2",
                alt: "property"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"d-flex justify-content-between mb-3\"><h3 class=\"mb-0 text-danger\">$350,000</h3><span class=\"text-danger bg-danger bg-opacity-10 d-inline-block fs-12 px-2 rounded-2\"> Sold </span></div><div class=\"d-flex align-items-center mb-3\"><span class=\"material-symbols-outlined fs-20 text-primary\"> location_on </span><span class=\"ms-1\">18 Chemin Challet</span></div><ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap gap-2 gap-md-4 border-top border-bottom py-2 mb-4\"><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\"> bed </span><span class=\"ms-2\">6 Bed</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\"> bathtub </span><span class=\"ms-2\">5 Bath</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\"> square_foot </span><span class=\"ms-2\">1800 sqft</span></div></li></ul>", 3)),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/agent-overview",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_5,
                    style: {"width":"40px","height":"40px"},
                    class: "rounded-circle border border-white",
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-16 fw-semibold" }, "Harold Cook"),
                  _createElementVNode("span", { class: "fs-13 text-body" }, "Owner")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-primary fs-15 text-decoration-none read"
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode(" View More ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createElementVNode("h3", { class: "mb-0" }, "Australia", -1)
              ]))]),
              _: 1
            }),
            _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div>", 1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/real-estate/property-overview",
            class: "text-decoration-none d-block mb-4"
          }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
              _createElementVNode("img", {
                src: _imports_6,
                class: "rounded-2",
                alt: "property"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"d-flex justify-content-between mb-3\"><h3 class=\"mb-0 text-danger\">$158,000</h3><span class=\"text-primary bg-primary bg-opacity-10 d-inline-block fs-12 px-2 rounded-2\">Rent</span></div><div class=\"d-flex align-items-center mb-3\"><span class=\"material-symbols-outlined fs-20 text-primary\">location_on</span><span class=\"ms-1\">51 Decca Road GUNN</span></div><ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap gap-2 gap-md-4 border-top border-bottom py-2 mb-4\"><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bed</span><span class=\"ms-2\">8 Bed</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bathtub</span><span class=\"ms-2\">8 Bath</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">square_foot</span><span class=\"ms-2\">2000 sqft</span></div></li></ul>", 3)),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/agent-overview",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_7,
                    style: {"width":"40px","height":"40px"},
                    class: "rounded-circle border border-white",
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-16 fw-semibold" }, "Steven Bryant"),
                  _createElementVNode("span", { class: "fs-13 text-body" }, "Owner")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-primary fs-15 text-decoration-none read"
            }, {
              default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                _createTextVNode(" View More ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createElementVNode("h3", { class: "mb-0" }, "Italy", -1)
              ]))]),
              _: 1
            }),
            _cache[25] || (_cache[25] = _createStaticVNode("<div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div>", 1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/real-estate/property-overview",
            class: "text-decoration-none d-block mb-4"
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
              _createElementVNode("img", {
                src: _imports_8,
                class: "rounded-2",
                alt: "property"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[29] || (_cache[29] = _createStaticVNode("<div class=\"d-flex justify-content-between mb-3\"><h3 class=\"mb-0 text-danger\">$99,000</h3><span class=\"text-danger bg-danger bg-opacity-10 d-inline-block fs-12 px-2 rounded-2\">Sold</span></div><div class=\"d-flex align-items-center mb-3\"><span class=\"material-symbols-outlined fs-20 text-primary\">location_on</span><span class=\"ms-1\">35 Vicolo Tre Marchetti</span></div><ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap gap-2 gap-md-4 border-top border-bottom py-2 mb-4\"><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bed</span><span class=\"ms-2\">6 Bed</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bathtub</span><span class=\"ms-2\">5 Bath</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">square_foot</span><span class=\"ms-2\">1500 sqft</span></div></li></ul>", 3)),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/agent-overview",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_9,
                    style: {"width":"40px","height":"40px"},
                    class: "rounded-circle border border-white",
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-16 fw-semibold" }, "Jannie James"),
                  _createElementVNode("span", { class: "fs-13 text-body" }, "Owner")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-primary fs-15 text-decoration-none read"
            }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                _createTextVNode(" View More ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                _createElementVNode("h3", { class: "mb-0" }, "Germany", -1)
              ]))]),
              _: 1
            }),
            _cache[31] || (_cache[31] = _createStaticVNode("<div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div>", 1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/real-estate/property-overview",
            class: "text-decoration-none d-block mb-4"
          }, {
            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
              _createElementVNode("img", {
                src: _imports_10,
                class: "rounded-2",
                alt: "property"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[35] || (_cache[35] = _createStaticVNode("<div class=\"d-flex justify-content-between mb-3\"><h3 class=\"mb-0 text-danger\">$110,000</h3><span class=\"text-success bg-success bg-opacity-10 d-inline-block fs-12 px-2 rounded-2\">Sale</span></div><div class=\"d-flex align-items-center mb-3\"><span class=\"material-symbols-outlined fs-20 text-primary\">location_on</span><span class=\"ms-1\">Ansbacher Strasse 44</span></div><ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap gap-2 gap-md-4 border-top border-bottom py-2 mb-4\"><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bed</span><span class=\"ms-2\">10 Bed</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bathtub</span><span class=\"ms-2\">10 Bath</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">square_foot</span><span class=\"ms-2\">2500 sqft</span></div></li></ul>", 3)),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/agent-overview",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_11,
                    style: {"width":"40px","height":"40px"},
                    class: "rounded-circle border border-white",
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-16 fw-semibold" }, "Larry Greenberg"),
                  _createElementVNode("span", { class: "fs-13 text-body" }, "Owner")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-primary fs-15 text-decoration-none read"
            }, {
              default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                _createTextVNode(" View More ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                _createElementVNode("h3", { class: "mb-0" }, "Poland", -1)
              ]))]),
              _: 1
            }),
            _cache[37] || (_cache[37] = _createStaticVNode("<div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div>", 1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/real-estate/property-overview",
            class: "text-decoration-none d-block mb-4"
          }, {
            default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
              _createElementVNode("img", {
                src: _imports_12,
                class: "rounded-2",
                alt: "property"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[41] || (_cache[41] = _createStaticVNode("<div class=\"d-flex justify-content-between mb-3\"><h3 class=\"mb-0 text-danger\">$150,500</h3><span class=\"text-primary bg-primary bg-opacity-10 d-inline-block fs-12 px-2 rounded-2\">Rent</span></div><div class=\"d-flex align-items-center mb-3\"><span class=\"material-symbols-outlined fs-20 text-primary\">location_on</span><span class=\"ms-1\">Czerwonych Beretów 124</span></div><ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap gap-2 gap-md-4 border-top border-bottom py-2 mb-4\"><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bed</span><span class=\"ms-2\">6 Bed</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bathtub</span><span class=\"ms-2\">5 Bath</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">square_foot</span><span class=\"ms-2\">1800 sqft</span></div></li></ul>", 3)),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/agent-overview",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_13,
                    style: {"width":"40px","height":"40px"},
                    class: "rounded-circle border border-white",
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-16 fw-semibold" }, "Kara Spangler"),
                  _createElementVNode("span", { class: "fs-13 text-body" }, "Owner")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-primary fs-15 text-decoration-none read"
            }, {
              default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                _createTextVNode(" View More ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                _createElementVNode("h3", { class: "mb-0" }, "Norway", -1)
              ]))]),
              _: 1
            }),
            _cache[43] || (_cache[43] = _createStaticVNode("<div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div>", 1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/real-estate/property-overview",
            class: "text-decoration-none d-block mb-4"
          }, {
            default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
              _createElementVNode("img", {
                src: _imports_14,
                class: "rounded-2",
                alt: "property"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[47] || (_cache[47] = _createStaticVNode("<div class=\"d-flex justify-content-between mb-3\"><h3 class=\"mb-0 text-danger\">$120,000</h3><span class=\"text-primary bg-primary bg-opacity-10 d-inline-block fs-12 px-2 rounded-2\">Rent</span></div><div class=\"d-flex align-items-center mb-3\"><span class=\"material-symbols-outlined fs-20 text-primary\">location_on</span><span class=\"ms-1\">Moeneveien 228 VARTEIG</span></div><ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap gap-2 gap-md-4 border-top border-bottom py-2 mb-4\"><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bed</span><span class=\"ms-2\">5 Bed</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bathtub</span><span class=\"ms-2\">5 Bath</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">square_foot</span><span class=\"ms-2\">1400 sqft</span></div></li></ul>", 3)),
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/agent-overview",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_15,
                    style: {"width":"40px","height":"40px"},
                    class: "rounded-circle border border-white",
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-16 fw-semibold" }, "Benjamin Dinh"),
                  _createElementVNode("span", { class: "fs-13 text-body" }, "Owner")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-primary fs-15 text-decoration-none read"
            }, {
              default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                _createTextVNode(" View More ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                _createElementVNode("h3", { class: "mb-0" }, "Netherland", -1)
              ]))]),
              _: 1
            }),
            _cache[49] || (_cache[49] = _createStaticVNode("<div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div>", 1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/real-estate/property-overview",
            class: "text-decoration-none d-block mb-4"
          }, {
            default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
              _createElementVNode("img", {
                src: _imports_16,
                class: "rounded-2",
                alt: "property"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[53] || (_cache[53] = _createStaticVNode("<div class=\"d-flex justify-content-between mb-3\"><h3 class=\"mb-0 text-danger\">$190,000</h3><span class=\"text-success bg-success bg-opacity-10 d-inline-block fs-12 px-2 rounded-2\">Sale</span></div><div class=\"d-flex align-items-center mb-3\"><span class=\"material-symbols-outlined fs-20 text-primary\">location_on</span><span class=\"ms-1\">Overburgkade 23</span></div><ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap gap-2 gap-md-4 border-top border-bottom py-2 mb-4\"><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bed</span><span class=\"ms-2\">6 Bed</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bathtub</span><span class=\"ms-2\">6 Bath</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">square_foot</span><span class=\"ms-2\">1900 sqft</span></div></li></ul>", 3)),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/agent-overview",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_17,
                    style: {"width":"40px","height":"40px"},
                    class: "rounded-circle border border-white",
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-16 fw-semibold" }, "Jane Wright"),
                  _createElementVNode("span", { class: "fs-13 text-body" }, "Owner")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-primary fs-15 text-decoration-none read"
            }, {
              default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                _createTextVNode(" View More ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_47, [
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                _createElementVNode("h3", { class: "mb-0" }, "Spain", -1)
              ]))]),
              _: 1
            }),
            _cache[55] || (_cache[55] = _createStaticVNode("<div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div>", 1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/real-estate/property-overview",
            class: "text-decoration-none d-block mb-4"
          }, {
            default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
              _createElementVNode("img", {
                src: _imports_18,
                class: "rounded-2",
                alt: "property"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[59] || (_cache[59] = _createStaticVNode("<div class=\"d-flex justify-content-between mb-3\"><h3 class=\"mb-0 text-danger\">$155,000</h3><span class=\"text-success bg-success bg-opacity-10 d-inline-block fs-12 px-2 rounded-2\">Sale</span></div><div class=\"d-flex align-items-center mb-3\"><span class=\"material-symbols-outlined fs-20 text-primary\">location_on</span><span class=\"ms-1\">Paseo Junquera, 98</span></div><ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap gap-2 gap-md-4 border-top border-bottom py-2 mb-4\"><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bed</span><span class=\"ms-2\">6 Bed</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bathtub</span><span class=\"ms-2\">5 Bath</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">square_foot</span><span class=\"ms-2\">1800 sqft</span></div></li></ul>", 3)),
          _createElementVNode("div", _hoisted_51, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/agent-overview",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_19,
                    style: {"width":"40px","height":"40px"},
                    class: "rounded-circle border border-white",
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-16 fw-semibold" }, "Kirk Jensen"),
                  _createElementVNode("span", { class: "fs-13 text-body" }, "Owner")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-primary fs-15 text-decoration-none read"
            }, {
              default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                _createTextVNode(" View More ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                _createElementVNode("h3", { class: "mb-0" }, "Hungary", -1)
              ]))]),
              _: 1
            }),
            _cache[61] || (_cache[61] = _createStaticVNode("<div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div>", 1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/real-estate/property-overview",
            class: "text-decoration-none d-block mb-4"
          }, {
            default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
              _createElementVNode("img", {
                src: _imports_20,
                class: "rounded-2",
                alt: "property"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[65] || (_cache[65] = _createStaticVNode("<div class=\"d-flex justify-content-between mb-3\"><h3 class=\"mb-0 text-danger\">$340,000</h3><span class=\"text-danger bg-danger bg-opacity-10 d-inline-block fs-12 px-2 rounded-2\">Sold</span></div><div class=\"d-flex align-items-center mb-3\"><span class=\"material-symbols-outlined fs-20 text-primary\">location_on</span><span class=\"ms-1\">8985 Becsvölgye Nyár utca</span></div><ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap gap-2 gap-md-4 border-top border-bottom py-2 mb-4\"><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bed</span><span class=\"ms-2\">10 Bed</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bathtub</span><span class=\"ms-2\">10 Bath</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">square_foot</span><span class=\"ms-2\">2500 sqft</span></div></li></ul>", 3)),
          _createElementVNode("div", _hoisted_56, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/agent-overview",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_21,
                    style: {"width":"40px","height":"40px"},
                    class: "rounded-circle border border-white",
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-16 fw-semibold" }, "Harold Cook"),
                  _createElementVNode("span", { class: "fs-13 text-body" }, "Owner")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-primary fs-15 text-decoration-none read"
            }, {
              default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                _createTextVNode(" View More ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                _createElementVNode("h3", { class: "mb-0" }, "Potugal", -1)
              ]))]),
              _: 1
            }),
            _cache[67] || (_cache[67] = _createStaticVNode("<div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash\"></i> Delete </a></li></ul></div>", 1))
          ]),
          _createVNode(_component_RouterLink, {
            to: "/real-estate/property-overview",
            class: "text-decoration-none d-block mb-4"
          }, {
            default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
              _createElementVNode("img", {
                src: _imports_22,
                class: "rounded-2",
                alt: "property"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[71] || (_cache[71] = _createStaticVNode("<div class=\"d-flex justify-content-between mb-3\"><h3 class=\"mb-0 text-danger\">$250,000</h3><span class=\"text-success bg-success bg-opacity-10 d-inline-block fs-12 px-2 rounded-2\">Sale</span></div><div class=\"d-flex align-items-center mb-3\"><span class=\"material-symbols-outlined fs-20 text-primary\">location_on</span><span class=\"ms-1\">Largo Prazeres 32</span></div><ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap gap-2 gap-md-4 border-top border-bottom py-2 mb-4\"><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bed</span><span class=\"ms-2\">6 Bed</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">bathtub</span><span class=\"ms-2\">5 Bath</span></div></li><li><div class=\"d-flex align-items-center\"><span class=\"material-symbols-outlined fs-18 text-danger\">square_foot</span><span class=\"ms-2\">1800 qft</span></div></li></ul>", 3)),
          _createElementVNode("div", _hoisted_61, [
            _createVNode(_component_RouterLink, {
              to: "/real-estate/agent-overview",
              class: "d-flex align-items-center text-decoration-none"
            }, {
              default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_23,
                    style: {"width":"40px","height":"40px"},
                    class: "rounded-circle border border-white",
                    alt: "user"
                  })
                ], -1),
                _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-16 fw-semibold" }, "Judith Brooks"),
                  _createElementVNode("span", { class: "fs-13 text-body" }, "Owner")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/real-estate/property-overview",
              class: "text-primary fs-15 text-decoration-none read"
            }, {
              default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                _createTextVNode(" View More ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("div", _hoisted_63, [
        _createVNode(_component_Pagination, {
          total: "30",
          items: "12"
        })
      ])
    ])
  ]))
}